var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "d-flex justify-space-between" }, [
        _c(
          "div",
          { staticClass: "flex flex-col lg:flex-row lg:items-center" },
          [
            _c("text-field-label", {
              staticClass: "mr-6",
              attrs: { label: "ขนส่ง Shopee Xpress" },
            }),
            !_vm.expand
              ? _c(
                  "v-chip",
                  {
                    staticClass: "chip-warning lg:self-center self-start",
                    attrs: {
                      color: "warning",
                      small: "",
                      label: "",
                      outlined: "",
                    },
                  },
                  [_vm._v(" New ")]
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass:
              "flex lg:flex-row flex-col lg:items-center items-end justify-end gap-1",
          },
          [
            _vm.shippingId && _vm.shippingSecret
              ? _c(
                  "v-chip",
                  {
                    staticClass: "chip-success",
                    attrs: { color: "success", outlined: "" },
                  },
                  [
                    _c("v-icon", { attrs: { left: "", small: "" } }, [
                      _vm._v(" mdi-check-circle "),
                    ]),
                    _vm._v(" เปิดใช้งาน "),
                  ],
                  1
                )
              : _c(
                  "v-chip",
                  {
                    staticClass: "chip-error",
                    attrs: { color: "error", outlined: "" },
                  },
                  [
                    _c("v-icon", { attrs: { left: "", small: "" } }, [
                      _vm._v(" mdi-close-circle "),
                    ]),
                    _vm._v(" ยังไม่เปิดใช้งาน "),
                  ],
                  1
                ),
            _c(
              "v-btn",
              {
                attrs: { color: "primary", text: "", rounded: "" },
                on: {
                  click: function ($event) {
                    _vm.expand = !_vm.expand
                  },
                },
              },
              [
                _vm.expand
                  ? _c("text-field-label", {
                      staticClass: "mt-2",
                      staticStyle: {
                        color: "var(--v-primary-base) !important",
                      },
                      attrs: { label: "ยกเลิก" },
                    })
                  : _c("text-field-label", {
                      staticClass: "mt-2",
                      staticStyle: {
                        color: "var(--v-primary-base) !important",
                      },
                      attrs: { label: "แก้ไข" },
                    }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("v-expand-transition", [
        _vm.expand
          ? _c(
              "div",
              [
                _c(
                  "v-row",
                  {
                    staticClass: "pl-12 mt-4 mb-4",
                    attrs: { "no-gutters": "" },
                  },
                  [
                    _c(
                      "v-col",
                      { staticClass: "pl-8", attrs: { cols: "4" } },
                      [
                        _c("text-field-label", {
                          attrs: { label: "การเข้ารับ" },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      [
                        _c("select-form", {
                          staticStyle: { "max-width": "300px" },
                          attrs: {
                            items: _vm.shopeeExpressPickupSelectableItem,
                            "item-value": "value",
                            "item-text": "text",
                            attach: true,
                          },
                          on: {
                            input: function ($event) {
                              return _vm.submit("shopeeExpressPickup")
                            },
                          },
                          model: {
                            value: _vm.form.shopeeExpressPickup,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "shopeeExpressPickup", $$v)
                            },
                            expression: "form.shopeeExpressPickup",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  {
                    staticClass: "pl-12 mt-4 mb-4",
                    attrs: { "no-gutters": "" },
                  },
                  [
                    _c(
                      "v-col",
                      { staticClass: "pl-8", attrs: { cols: "4" } },
                      [_c("text-field-label", { attrs: { label: "User id" } })],
                      1
                    ),
                    _c(
                      "v-col",
                      [
                        _c("v-text-field", {
                          staticStyle: { "max-width": "300px" },
                          attrs: {
                            "hide-details": "",
                            autofocus: "",
                            outlined: "",
                            dense: "",
                          },
                          on: {
                            input: function ($event) {
                              return _vm.debounceValidToken($event)
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "append",
                                fn: function () {
                                  return [
                                    _c("v-fade-transition", [
                                      _c(
                                        "div",
                                        { staticClass: "mt-1" },
                                        [
                                          _vm.validShipingId
                                            ? _c("v-img", {
                                                attrs: {
                                                  src: _vm.getIcon(
                                                    _vm.validShipingId
                                                  ),
                                                  height: "16",
                                                  eager: "",
                                                  contain: "",
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            969125475
                          ),
                          model: {
                            value: _vm.form.shopeeExpressId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "shopeeExpressId", $$v)
                            },
                            expression: "form.shopeeExpressId",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  {
                    staticClass: "pl-12 mt-4 mb-4",
                    attrs: { "no-gutters": "" },
                  },
                  [
                    _c(
                      "v-col",
                      { staticClass: "pl-8", attrs: { cols: "4" } },
                      [
                        _c("text-field-label", {
                          attrs: { label: "User secret " },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      [
                        _c("v-text-field", {
                          staticStyle: { "max-width": "300px" },
                          attrs: {
                            "hide-details": "",
                            outlined: "",
                            dense: "",
                          },
                          on: {
                            input: function ($event) {
                              return _vm.debounceValidToken($event)
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "append",
                                fn: function () {
                                  return [
                                    _c("v-fade-transition", [
                                      _c(
                                        "div",
                                        { staticClass: "mt-1" },
                                        [
                                          _vm.validShipingSecret
                                            ? _c("v-img", {
                                                attrs: {
                                                  src: _vm.getIcon(
                                                    _vm.validShipingSecret
                                                  ),
                                                  height: "16",
                                                  eager: "",
                                                  contain: "",
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            400198531
                          ),
                          model: {
                            value: _vm.form.shopeeExpressSecret,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "shopeeExpressSecret", $$v)
                            },
                            expression: "form.shopeeExpressSecret",
                          },
                        }),
                        _c("save-change-button", {
                          staticClass: "mt-3",
                          attrs: {
                            disabled: !_vm.valid,
                            state: _vm.state,
                            label: _vm.$t("shipping.btn.save"),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.submit()
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }